import { useMutation } from "react-query";
import http from "infra/http";
import { ClienteDetalheResponse } from "core/features/cliente/typings";

function useSaveCliente(id?: string) {
  return useMutation(
    [`/v1/cliente`, id],
    (data: ClienteDetalheResponse) => {
      data.pessoa.contatos = Array.isArray(data.pessoa.contatos)
        ? data.pessoa.contatos
        : [];

      if (!id) {
        return http.post<{ clienteId: string; pessoaId: string }>(
          `/v1/cliente`,
          data
        );
      }

      return http.put<{ clienteId: string; pessoaId: string }>(
        `/v1/cliente/${id}`,
        data
      );
    },
    { retry: false }
  );
}

export default useSaveCliente;
